import React from "react";
import Typed from "react-typed";
import BackgroundHome from "../img/svg/index-background.svg";
import Me from "../img/svg/me-background.svg";
import Code from "../img/svg/code-background.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoffee, faLaptopCode } from "@fortawesome/free-solid-svg-icons";

import Fade from "react-reveal/Fade";

import "./Home.css";

export default function Home() {
  let language = localStorage.getItem("language");

  return (
    <div className="home">
      <Fade cascade>
        <div className="home-div">
          <img
            src={BackgroundHome}
            alt="Background home"
            className="home-div__img"
          />
          <h2
            className="home-div__text"
            style={language === "english" ? {} : { display: "none" }}
          >
            <br />
            Doing your{" "}
            <Typed
              strings={[
                "<i class='typed-text' style='color: #3137D4 ;'>products</h2>",
                "<i class='typed-text' style='color: #852 ;'>designs</h2>",
                "<i class='typed-text' style='color: #eb7d34 ;'>software</h2>",
                "<i class='typed-text' style='color: #ff3103 ;'>ideas</h2>",
                "<i class='typed-text' style='color: #370270 ;'>dreams</h2>",
              ]}
              typeSpeed={40}
              backSpeed={50}
              loop
            />
            <br />
            reality
          </h2>
          <h2
            className="home-div__text"
            style={
              language === "español" || !language ? {} : { display: "none" }
            }
          >
            <br />
            Haciendo tus{" "}
            <Typed
              strings={[
                "<i class='typed-text' style='color: #3137D4 ;'>productos</h2>",
                "<i class='typed-text' style='color: #852 ;'>diseños</h2>",
                "<i class='typed-text' style='color: #eb7d34 ;'>sistemas</h2>",
                "<i class='typed-text' style='color: #ff3103 ;'>ideas</h2>",
                "<i class='typed-text' style='color: #370270 ;'>sueños</h2>",
              ]}
              typeSpeed={40}
              backSpeed={50}
              loop
            />
            <br />
            realidad
          </h2>
        </div>
      </Fade>

      <div className="home-me">
        <Fade left>
          <img src={Me} alt="Me" className="home-me__img" />
        </Fade>
        <Fade right>
          <p
            className="home-me__text"
            style={language === "english" ? {} : { display: "none" }}
          >
            Developer and coder 50% <FontAwesomeIcon icon={faCoffee} />, 50%{" "}
            <FontAwesomeIcon icon={faLaptopCode} />, 100% <b>Productivity</b>.
          </p>
          <p
            className="home-me__text"
            style={
              language === "español" || !language ? {} : { display: "none" }
            }
          >
            Desarrollador y codificador 50% <FontAwesomeIcon icon={faCoffee} />,
            50% <FontAwesomeIcon icon={faLaptopCode} />, 100%{" "}
            <b>Productividad</b>.
          </p>
        </Fade>
      </div>
      <div className="home-ideas">
        <Fade left>
          <p
            className="home-ideas__text"
            style={language === "english" ? {} : { display: "none" }}
          >
            Bring me your ideas, i will do it with hard <b>work</b> and{" "}
            <b>love</b>.
          </p>
          <p
            className="home-ideas__text"
            style={
              language === "español" || !language ? {} : { display: "none" }
            }
          >
            Dame tus ideas, las haré realidad con <b>trabajo</b> duro y{" "}
            <b>amor</b>.
          </p>
        </Fade>
        <Fade right>
          <img src={Code} alt="Me Code" className="home-ideas__img" />
        </Fade>
      </div>
    </div>
  );
}
